import { ReportErrorsService } from './report-errors.service';

export default angular
  .module('sfMobile.services.reportErrors', [
    'sfMobile.services.forms',
    'sfMobile.constants.question-product',
  ])
  .factory('ReportErrorsService', ReportErrorsService).name;
